export default "/images/f2d9db1f1036c5acf5a9eb032bcf257e.avif";